import React from "react";
import { Close } from "../../Icons/IconPackage/Close";
import ButtonQuestionWriteForm from "../ButtonQuestionWriteForm";
import ButtonQuestionWriteFormWrapper from "../../QuestionMessages/ButtonQuestionWriteFormWrapper";
import Module from "../Module";
import Tabs from "../Tabs";
import "./style.scss";

const ModuleMobile = ({
    moduleRef,
    modules = [],
    currentModule,
    setCurrentModule,
    handleOpenQuestionWriteForm,
    isFullscreen = false,
    settings,
    isOpen,
    onOpen,
    isClose = true,
}) => {
    const classNameBottomSheet = 'side-module-mobile';
    const questionsEnabled = modules.map(({ name }) => name).includes('questions');

    return (
        <div className={`${classNameBottomSheet} ${isFullscreen ? '-fullscreen' : ''}`}>
            <div className={`${classNameBottomSheet}-container ${questionsEnabled ? '-questions' : ''}`}>
                <div className={`${classNameBottomSheet}-header`}>
                    {!isFullscreen && <div className={`${classNameBottomSheet}-resizer-container`} onClick={() => onOpen(!isOpen)}>
                        <div className={`${classNameBottomSheet}-resizer ${isOpen ? '-open' : ''}`}></div>
                    </div>}
                    {isClose && (
                        <div
                            className={`${classNameBottomSheet}-close-button`}
                            onClick={() => setCurrentModule(null)}
                        >
                            <Close />
                        </div>
                    )}
                </div>

                <div className={`${classNameBottomSheet}-menu`}>
                    <span className={`${classNameBottomSheet}-menu-line`}></span>
                    <Tabs
                        modules={modules.map(({ name }) => name)}
                        currentModule={currentModule}
                        setCurrentModule={setCurrentModule}
                    />
                </div>
                <div className="modules-container">
                    <Module
                        module={currentModule}
                        moduleRef={moduleRef}
                    />
                </div>
            </div>

            <ButtonQuestionWriteFormWrapper
                moduleRef={moduleRef}
                settings={settings}
                onClick={handleOpenQuestionWriteForm}
                ButtonComponent={ButtonQuestionWriteForm}
            />
        </div>
    );
}

export default ModuleMobile;
